// Variable interpolation for {{var_name}} tokens inside authored text.
//
// The authored content is HTML (TipTap StarterKit output) so we substitute
// at the string level before render, NOT after parsing. Substitutions are
// HTML-escaped to prevent injection from variable values.
// The token grammar is NOT defined here. `\w` excludes `.`, so a local
// `[\w_]+` pattern silently fails to match canonical scoped tokens
// (`{{recipient.first_name}}`) — they match nothing and pass through to the
// caregiver as literal `{{recipient.first_name}}` text. Phase 1 made scoped
// names canonical and the publish gate now REQUIRES them, so every workflow
// authored on the canvas hit this. shared-types owns the one grammar; the
// factory exists so no consumer inherits another's `lastIndex`.
import { interpolationPattern } from '@little-loop/shared-types';
const HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (ch) => HTML_ESCAPE_MAP[ch] ?? ch);
}
/** A "chip" rendering of an unresolved variable token (preview / no-value mode). */
const TOKEN_CHIP_CLASS = 'inline-block bg-teal-100 text-teal-700 text-[0.75em] font-mono ' +
    'px-1.5 py-0.5 rounded mx-0.5 leading-none align-baseline';
export function interpolate(html, opts) {
    return html.replace(interpolationPattern(), (_match, name) => {
        const resolved = opts.mode === 'play'
            ? opts.values[name] ?? opts.examples?.[name]
            : opts.examples?.[name] ?? opts.values[name];
        if (resolved !== undefined && resolved !== null && resolved !== '') {
            return escapeHtml(resolved);
        }
        // Unresolved — render the token name as a chip so the recipient sees
        // exactly what was missing.
        return `<span class="${TOKEN_CHIP_CLASS}">${escapeHtml(name)}</span>`;
    });
}
/**
 * Strip {{var}} tokens for accessibility text where chip markup wouldn't help.
 * Used for `aria-label`s and the like.
 */
export function stripTokens(text) {
    return text.replace(interpolationPattern(), (_match, name) => name);
}
